export default {
  pcLayout: {
    quotationDeadline: 'Quotation Deadline',
    expectedArrivalTime: 'Expected Arrival Time',
    expectedDeliveryTime: 'Expected Delivery Time',
    addresses: 'Loading Point and Delivery Address',
    quantity: 'Quantity',
    amount: 'Amount',
    actions: 'Actions',
    deleteFee: 'Delete Fee',
    loadingAddress: 'Loading Point',
    deliveryAddress: 'Last Mile Delivery Address'
  },

  // Address type enum (maps to pre_address_type / last_address_type fields)
  addressType: {
    seaport: 'Seaport',
    airport: 'Airport',
    railwayStation: 'Railway Station'
  },

  // Quotation Change Formatter
  changeFormatter: {
    itemAdded: '{project} added',
    itemDeleted: '{project} deleted',
    projectChanged: '{oldProject} changed to {newProject}',
    amountChanged: 'Amount changed from {oldAmount} {oldCurrency} to {newAmount} {newCurrency}',
    projectWithChange: '{project} {change}',
    separator: ', '
  },

  // Supplier Quotation Detail Page
  supplierQuotationDetail: {
    // Supplier Information
    supplierName: 'Supplier Name',
    inquirer: 'Inquirer',
    onePriceSupported: 'All In Price',
    flightNo: 'Flight No.',
    validPeriod: 'Quotation Validity',
    validPeriodSeparator: 'to',
    roroQuotationTitle: 'RoRo Quotation Details',
    bulkCargoQuotationTitle: 'Breakbulk Quotation Details',
    totalAmount: 'Total Amount',
    totalAmountByCurrency: 'Total by Currency',
    feeDetails: 'Fee Details',
    oceanFreight: 'Ocean Freight',
    perContainerPrice: 'Per Container Price',
    originCharges: 'Origin Charges',
    destCharges: 'Dest Charges',
    potentialCharges: 'Potential Charges',
    potentialChargesTip: 'Potential costs, not included in the total price for now',
    addOceanSurcharge: 'Add Ocean Surcharge',
    addOriginCharge: 'Add Origin Charge',
    addDestCharge: 'Add Dest Charge',
    addPotentialCharge: 'Add Potential Charge',
    prepaid: 'Prepaid',
    collect: 'Collect',
    perContainer: 'Per Container',
    perBill: 'Per Bill',
    containerType: 'Container Type',

    roro: {
      title: 'Vehicle Information',
      itemTitle: 'Vehicle {index}',
      vehicleType: 'Vehicle Type',
      brandModel: 'Brand/Model',
      quantity: 'Vehicle Quantity',
      lengthMm: 'Vehicle Length (mm)',
      widthMm: 'Vehicle Width (mm)',
      heightMm: 'Vehicle Height (mm)',
      weightTon: 'Vehicle Weight (Ton)',
      remarks: 'Remarks',
      empty: 'No vehicle details',
      scheduleTitle: 'Schedule Requirements',
      expectedEtd: 'Expected ETD',
      expectedEta: 'Expected ETA',
      acceptTransit: 'Accept Transit',
      transitDaysRequirement: 'Transit Days Requirement',
      transitDaysWithin: 'Within {days} days'
    },

    bulkCargo: {
      title: 'Breakbulk Cargo Information',
      itemTitle: 'Cargo {index}',
      cargoKind: 'Cargo Type',
      tonnage: 'Tonnage',
      volume: 'Volume',
      stowageFactor: 'Stowage Factor',
      packagingType: 'Packaging',
      liftingRequirements: 'Lifting Requirements',
      receivingInstructions: 'Special Receiving Instructions',
      remarks: 'Remarks',
      groupCount: 'Cargo Groups',
      totalTonnage: 'Total Tonnage',
      totalVolume: 'Total Volume',
      empty: 'No breakbulk cargo details'
    },

    // Quotation Detail
    quotationDetail: 'Quotation Detail',
    serviceContent: 'Service Content',
    addItem: 'Add',
    project: 'Project Name',
    projectPlaceholder: 'Enter project name',
    feeType: 'Fee Category',
    feeTypes: {
      0: 'Basic Ocean Freight',
      1: 'Ocean Surcharge',
      2: 'Origin Charges',
      3: 'Dest Charges',
      4: 'Potential Charges'
    },
    placeholders: {
      selectOption: 'Please select'
    },
    unit: 'Unit',
    unitPlaceholder: 'Unit',
    quantity: 'Quantity',
    quantityPlaceholder: 'Quantity',
    unitPrice: 'Unit Price',
    unitPricePlaceholder: 'Unit price',
    amount: 'Amount',
    currency: 'Currency',
    currencyPlaceholder: 'Currency',
    remarks: 'Remarks',
    remarksPlaceholder: 'Remarks',
    operations: 'Operations',
    deleteRow: 'Delete',

    // Unit Options
    units: {
      container: 'Container',
      ticket: 'Ticket',
      ton: 'Ton',
      cbm: 'CBM',
      bill: 'Bill',
      set: 'Set'
    },

    // Currency Options
    currencies: {
      CNY: 'CNY',
      USD: 'USD',
      EUR: 'EUR',
      HKD: 'HKD'
    },

    // Consultation History
    consultationHistory: 'Consultation History',
    initiateConsultation: 'Initiate Consultation',
    consultationContent: 'Consultation Content',
    consultationContentPlaceholder: 'Enter consultation content',
    initiatedByInquirer: 'Initiated by Inquirer',
    initiatedByQuoter: 'Initiated by Quoter',
    reply: 'Reply',
    attachment: 'Attachment',
    updatedBy: 'Updated By',
    updateTime: 'Update Time',
    changeContent: 'Change Content',
    consultationRemarks: 'Consultation Remarks',
    initialVersion: 'Initial Version',
    currentVersion: 'Current Version',
    reduced: 'Reduced',
    noChange: 'No Change',
    noConsultationRecords: 'No consultation records',

    // Consultation Status
    consultationStatus: {
      notConsulted: 'Not Consulted',
      inProgress: 'In Progress',
      completed: 'Completed'
    },

    // Voyage Information
    voyageInfo: 'Voyage Information',
    etd: 'ETD',
    eta: 'ETA',
    voyageFlight: 'Vessel/Voyage',
    transportationDays: 'Transit Days',
    days: 'Days',
    durationUnits: {
      day: 'Day',
      hour: 'Hour',
      minute: 'Minute',
      compactDay: 'D',
      compactHour: 'H',
      compactMinute: 'M'
    },

    // SHOKZ quotation service fields
    serviceFields: {
      serviceType: 'Service Type',
      serviceTypePlaceholder: 'Select service type',
      demurrageFreeDays: 'Free Demurrage Period',
      detentionFreeDays: 'Free Detention Period',
      weightLimit: 'Weight Limit',
      routeGrade: 'Route Grade',
      routeGradeNormal: 'Normal',
      routeGradeExpress: 'Express',
      serviceTypes: {
        seaFcl: 'FCL',
        seaLcl: 'LCL',
        roro: 'Ro-Ro',
        breakBulk: 'Breakbulk',
        looseCargo: 'Loose Cargo',
        fullPallet: 'Full Pallet',
        fullCabin: 'Full Cabin',
        charter: 'Charter',
        prePort: 'Pre-port Transport',
        lastMile: 'Last-mile Transport'
      },
      shippingLine: 'Shipping Line',
      airline: 'Airline',
      carrier: 'Carrier',
      railwayCompany: 'Railway Company',
      estimatedDepartureTime: 'Estimated Departure Time',
      estimatedArrivalTime: 'Estimated Arrival Time',
      vessel: 'Vessel',
      voyage: 'Voyage',
      bargeVessel: 'Barge Vessel',
      bargeVoyage: 'Barge Voyage',
      trainNo: 'Train No.',
      bargeDepartureTime: 'Barge Departure Time',
      bargeArrivalTime: 'Barge Arrival Time',
      trainDepartureTime: 'Train Departure Time',
      directTransit: 'Direct/Transit',
      transferPort: 'Transfer Port',
      multipleSelectionPlaceholder: 'Multiple selection supported',
      singleSelectionPlaceholder: 'Select one transfer location',
      locationPlaceholder: 'Select {location}',
      originPort: 'Origin Port',
      destinationPort: 'Port of Discharge (POD)',
      stuffingTerminal: 'Stuffing Terminal/Yard',
      deliveryTerminal: 'Delivery Terminal/Yard',
      loadingPort: 'Loading Port',
      dischargingPort: 'Discharging Port',
      arrivalPort: 'Arrival Port',
      arrivalStation: 'Arrival Station',
      dischargingStation: 'Discharging Station',
      dischargingAirport: 'Discharging Airport',
      arrivalTerminal: 'Arrival Terminal',
      originTerminal: 'Discharging Terminal',
      arrivalAirportTerminal: 'Arrival Airport Terminal',
      originAirportTerminal: 'Discharging Airport Terminal',
      sailingSchedule: 'Sailing Schedule',
      flightSchedule: 'Flight Schedule',
      transportationTime: 'Transit Time',
      transportationDays: 'Transit Time (Days)',
      transportationMode: 'Transport Mode',
      arrivalNodeType: 'Arrival/Unloading Node',
      segmentTruck: 'Truck',
      segmentBarge: 'Barge',
      segmentRail: 'Rail',
      seaPort: 'Seaport',
      railwayStation: 'Railway Station',
      airport: 'Airport',
      departureAirport: 'Departure Airport',
      arrivalAirport: 'Arrival Airport',
      loadingStation: 'Loading Railway Station',
      destinationStation: 'Destination Railway Station',
      destinationArea: 'Destination Area',
      segmentRouteInfo: 'Segment Route Information',
      directTruck: 'Direct Drayage',
      feeder: 'Feeder Service',
      seaRail: 'Sea-Rail',
      monday: 'Mon',
      tuesday: 'Tue',
      wednesday: 'Wed',
      thursday: 'Thu',
      friday: 'Fri',
      saturday: 'Sat',
      sunday: 'Sun',
      weekdaySeparator: ', ',
      customsCutoffTime: 'Customs Cut-off Time',
      weightCutoffTime: 'Weight Cut-off Time',
      timelinessAchievementRate: 'On-time Performance Rate',
      carrierPromiseDays: 'End-to-End Transit Time Commitment',
      airlinePromiseDays: 'Carrier End-to-End Transit Time Commitment',
      pickupLeadTime: 'Pickup Lead Time',
      portToPortDays: 'Port-to-Port Transit Time',
      clearanceDeliveryDays: 'Customs Clearance & Delivery Time',
      routeCode: 'Route Code',
      aircraftType: 'Aircraft Type',
      cabinVolume: 'Cargo Capacity',
      freeStorageDays: 'Destination Airport Free Storage Days',
      freeCfsStorageDays: 'CFS Free Storage Days',
      securityRequired: 'Cargo Security Check Required',
      securityRequirement: 'Security Instructions',
      specialCargoRequired: 'Special Cargo Transport Required',
      specialCargoDescription: 'Special Cargo Instructions',
      yes: 'Yes',
      no: 'No',
      daysValue: '{days} days'
    },

    // Route Mode
    routeMode: 'Route Mode',
    direct: 'Direct',
    transshipment: 'TransShipment',
    transshipmentPorts: 'Transit Ports',
    transshipmentPort1: '1st Transit Port',
    transshipmentPort2: '2nd Transit Port',
    transshipmentPort3: '3rd Transit Port',
    validation: {
      transshipmentPortRequired: 'At least one transit port must be selected in transshipment mode'
    },

    // Supplier Remarks
    supplierRemarks: 'Supplier Remarks',
    supplierRemarksPlaceholder: 'Enter supplier remarks',
    noRemarks: 'No remarks',

    // Button Operations
    edit: 'Edit',
    cancel: 'Cancel',
    save: 'Save',
    submit: 'Submit',
    confirmConsultation: 'Complete Consultation',
    confirmSupplier: 'Confirm Supplier',
    cancelConfirmSupplier: 'Cancel Confirmation',

    // AI Recognition
    aiRecognition: {
      buttonText: 'AI Recognition',
      modalTitle: 'AI Smart Recognition',
      inputLabel: 'Please paste supplier quotation text content',
      placeholder: 'Paste supplier quotation content, AI will automatically recognize and extract quotation details, voyage information, etc...',
      tip: 'Supports recognition of charging items, unit prices, quantities, currencies, and voyage information such as ETD, ETA, vessel/voyage, transit days',
      okText: 'Start Recognition',
      inputRequired: 'Please enter text content to recognize',
      emptyResult: 'No valid information recognized, please check the input',
      success: 'AI recognition successful, information has been auto-filled',
      failed: 'AI recognition failed, please try again later'
    },

    quotationPlans: {
      title: 'Quotation Plans',
      add: 'Add Plan',
      copy: 'Copy Plan',
      prefix: 'Plan ',
      onePrice: 'All In Price',
      direct: 'Direct',
      transit: 'Transit',
      unspecified: 'Unspecified'
    },

    // Messages
    messages: {
      missingQuotationId: 'Missing quotation ID',
      loadDataError: 'Failed to load data',
      anonymousLinkInvalid: 'The quotation link is invalid or has expired. Contact the inquirer for a new link.',
      anonymousLoadFailed: 'Failed to load quotation data. Please try again later.',
      addItemSuccess: 'New quotation detail line added, please fill in the information',
      deleteConfirmTitle: 'Confirm Delete',
      deleteConfirmContent: 'Are you sure to delete this quotation detail?',
      deleteSuccess: 'Deleted successfully',
      consultationContentRequired: 'Please enter consultation content',
      consultationSubmitSuccess: 'Consultation submitted successfully',
      consultationSubmitError: 'Failed to submit consultation',
      noConsultationRecords: 'No consultation records',
      noChargingItems: 'No charging items',
      saveSuccess: 'Saved successfully',
      saveError: 'Failed to save',
      submitSuccess: 'Submitted successfully',
      submitError: 'Failed to submit',
      cancelConfirmTitle: 'Confirm Cancel',
      cancelConfirmContent: 'Are you sure to cancel editing? Unsaved changes will be lost',
      consultationSuccess: 'Consultation completed successfully',
      consultationFailed: 'Consultation failed',
      quotationExpiredTitle: 'Quotation Closed',
      quotationExpiredContent: 'The quotation deadline has passed. You can only view this quotation and cannot edit or submit it.',
      quotationExpiredEdit: 'The quotation deadline has passed. Editing is not allowed.',
      quotationExpiredSubmit: 'The quotation deadline has passed. Submission is not allowed.',
      quotationConfirmedLocked: 'The supplier has been confirmed. Editing or further consultation is not allowed.',
      consultationAlreadyCompleted: 'This consultation has been completed. The customer must start another consultation before changes can be made.',
      selectTransferPort: 'Please select a transfer port',
      selectCarrier: 'Please select {carrier}',
      typeNotSupportEdit: 'Editing is not supported for the current quotation type',
      validPeriodRequired: 'Please select quotation validity period',
      destinationCountryInvalid: 'Destination country data is incomplete. Please refresh and try again.',
      validPeriodInvalid: 'The validity start date cannot be later than the end date',
      feeRequired: 'Please add at least one valid fee item',
      trunkFeeRequired: 'Please complete at least one {group} item',
      segmentFeeRequired: 'Please complete at least one {group} item',
      emptyFeeGroup: 'No {group}',
      addFeeGroup: 'Add {group}',
      feeFieldRequired: 'Please fill in {field} for {group} item {index}',
      feeMinMaxNonNegative: 'Minimum and maximum charges for {group} item {index} cannot be less than 0',
      feeMaxLessThanMin: 'Maximum charge for {group} item {index} cannot be less than minimum charge',
      containerPriceRequired: 'Enter at least one container price for {group} item {index}',
      feeGroupMismatch: 'Fee item {fee} does not belong to {group}; please select again',
      requiredFeeMissing: 'Required fee item [{fee}] is missing',
      requiredFeeDeleteDisabled: 'Required fee items cannot be deleted',
      planCreateSuccess: 'Quotation plan added',
      planCreateFailed: 'Failed to add quotation plan',
      planCopySuccess: 'Quotation plan copied',
      planCopyFailed: 'Failed to copy quotation plan',
      planSwitchUnsaved: 'Please save or cancel current editing before switching plans',
      planDeleteConfirm: 'Are you sure to delete this quotation plan?',
      planDeleteSuccess: 'Quotation plan deleted',
      planDeleteFailed: 'Failed to delete quotation plan',
      securityRequirementRequired: 'Please fill in security instructions when cargo security check is required',
      specialCargoDescriptionRequired: 'Please fill in special cargo instructions when special cargo transport is required',
      etaBeforeEtd: 'The estimated arrival time cannot be earlier than the estimated departure time',
      serviceFieldRequired: 'Please fill in {field}'
    },

    feeGroups: {
      basic: 'Basic Charges',
      oceanFreight: 'Ocean Freight',
      airFreight: 'Air Freight',
      fixed: 'Base Freight',
      prePort: 'Pre-port Charges',
      prePortSurcharge: 'Pre-carriage Surcharges',
      origin: 'Origin Charges',
      destination: 'Destination Charges',
      lastMile: 'Last-mile Charges',
      lastMileSurcharge: 'Last-mile Surcharges',
      surcharge: 'Surcharges',
      potential: 'Potential Charges'
    },

    feeFields: {
      project: 'fee name',
      potentialFeeType: 'fee type',
      measureId: 'billing unit',
      densityDegree: 'density grade',
      calcType: 'calculation type',
      quantity: 'quantity',
      billingQuantity: 'billing quantity',
      unitRate: 'unit price',
      currency: 'currency',
      prepaidCollect: 'prepaid/collect',
      weightBreak: 'weight break',
      minCharge: 'minimum charge',
      maxCharge: 'maximum charge',
      amount: 'amount',
      remarks: 'remarks'
    },

    airRate: {
      unitPrice: 'Unit Price',
      weightRate: 'Unit Price (Chargeable Weight)',
      densityGroup: 'Density Group {index}',
      selectDensityDegree: 'Select density grade range',
      selectCarrierFirst: 'Select an airline first',
      type: 'Type',
      rate: 'Rate',
      billingTerm: 'Billing Terms',
      minimumConsumption: 'Minimum Charge (M)',
      normalRate: 'Normal Rate (N)',
      addDensityGroup: 'Add Density Group'
    },

    potentialFeeTypes: {
      seaSurcharge: 'Ocean freight surcharge',
      airSurcharge: 'Air freight surcharge',
      seaOrigin: 'Origin port charge',
      seaDestination: 'Destination port charge',
      airOrigin: 'Origin charge',
      airDestination: 'Destination charge',
      prePortSurcharge: 'Pre-port surcharge',
      lastMileSurcharge: 'Last-mile surcharge'
    },

    calcTypes: {
      perCbm: 'Per Volume (CBM)',
      perTon: 'Per Ton (MT)',
      perPackage: 'Per Package',
      perBill: 'Per Bill',
      flat: 'Fixed Charge'
    },

    // Container Types
    containerTypes: {
      gp20: '20GP',
      gp40: '40GP',
      hc20: '20HC',
      hc40: '40HC',
      hc45: '45HC',
      nor20: '20NOR',
      nor40: '40NOR',
      tk20: '20TK',
      tk40: '40TK',
      ot20: '20OT',
      ot40: '40OT',
      fr20: '20FR',
      fr40: '40FR'
    }
  },

  supplierExpressQuotation: {
    title: 'Express Quotation Detail',
    titles: {
      EXPRESS: 'Express Quotation',
      LTL: 'LTL Quotation',
      FTL: 'FTL Quotation'
    },
    planCount: '{count} plans',
    planTitle: 'Plan {index}',
    emptyPlans: 'No quotation plans',
    emptySurcharges: 'No surcharges',
    sections: {
      inquiry: 'Inquiry Information',
      plans: 'Quotation Plans',
      currentPlan: 'Current Plan',
      quotationDetail: 'Quotation Details',
      consultationHistory: 'Consultation Records',
      basic: 'Basic Information',
      origin: 'Origin',
      destination: 'Destination',
      cargo: 'Cargo Information',
      baseFee: 'Base Fee',
      billing: 'Billing Rules',
      billingDetail: 'Billing Details',
      totalFee: 'Total Fee',
      onePrice: 'One-price',
      weightTiers: 'Weight Tiers',
      surcharges: 'Surcharges',
      ltlFees: 'Surcharges',
      vehicle: 'Vehicle Information',
      remarks: 'Remarks'
    },
    fields: {
      quotationNo: 'Quotation No.',
      inquiryNo: 'Inquiry No.',
      quoter: 'Quoter',
      inquiryNature: 'Inquiry Nature',
      palletNature: 'Cargo Nature',
      cargoReadyTime: 'Cargo Ready Time',
      transportTerms: 'Transport Terms',
      tradeTerms: 'Trade Terms',
      inquiryEnterprise: 'Inquiry Company',
      directTransit: 'Direct/Transit',
      expressCarrier: 'Express Carrier',
      loadMode: 'Load Mode',
      serviceType: 'Service Type',
      cargoType: 'Cargo Type',
      origin: 'Origin',
      destination: 'Destination',
      weight: 'Weight',
      actualWeight: 'Actual Total Weight (KGS)',
      actualTotalWeight: 'Actual Total Weight (KGS)',
      totalWeight: 'Cargo Total Weight (KGS)',
      cubage: 'Volume',
      totalCubage: 'Total Volume (CBM)',
      quantity: 'Quantity',
      remarks: 'Remarks',
      summaryQuantity: 'Total Quantity',
      summaryWeight: 'Total Gross Weight',
      summaryVolume: 'Total Volume',
      shipperRemarks: 'Shipper Remarks',
      supplierRemarks: 'Notes',
      dimensions: 'Single Piece Dimensions',
      cargoDescription: 'Cargo Description',
      expectedSailingTime: 'Expected Sailing Time',
      expectedTransitTime: 'Expected Transit Time',
      unNo: 'UN No.',
      cargoCategory: 'Class',
      cargoName: 'Cargo Name',
      hsCode: 'HSCODE',
      cargoValue: 'Cargo Value',
      quoteDeadline: 'Quote Deadline',
      specialRequirements: 'Special Requirements',
      country: 'Country',
      province: 'State/Province',
      city: 'City',
      district: 'District/County',
      street: 'Town/Street',
      detailAddress: 'Detail Address',
      postalCode: 'Postal Code',
      warehouse: 'Warehouse',
      lengthCm: 'Length (CM)',
      widthCm: 'Width (CM)',
      heightCm: 'Height (CM)',
      lengthM: 'Length (M)',
      widthM: 'Width (M)',
      heightM: 'Height (M)',
      needPickup: 'Pickup Required',
      needDelivery: 'Delivery Required',
      needUpstairs: 'Upstairs Delivery Required',
      needLoadingUnloading: 'Loading/Unloading Required',
      expectedVehicleType: 'Expected Vehicle Type',
      pricingPreference: 'Billing Preference',
      validPeriod: 'Valid Period',
      billingModel: 'Billing Model',
      billingMethod: 'Billing Method',
      currency: 'Currency',
      paymentTerm: 'Payment Term',
      volumetricFactor: 'Volumetric Factor',
      isOnePrice: 'One-price',
      firstWeightThreshold: 'First Weight',
      firstWeightThresholdKg: 'First Weight Threshold (KG)',
      firstWeightPrice: 'First Weight Price',
      additionalWeightUnit: 'Additional Weight Unit',
      additionalWeightUnitKg: 'Additional Weight Unit (KG)',
      additionalWeightPrice: 'Additional Weight Price',
      weightTierAdditionalWeightPrice: 'Additional Weight Unit Price',
      weightTierMinCharge: 'Minimum Charge (Total Price)',
      minCharge: 'Minimum Charge',
      minBillingWeight: 'Minimum Billing Weight',
      pickupFee: 'Pickup Fee',
      deliveryFee: 'Delivery Fee',
      loadingFee: 'Loading/Unloading Fee',
      unitPrice: 'Unit Price',
      unitPriceKg: 'Unit Price (KG)',
      unitPriceCbm: 'Unit Price (CBM)',
      unitPriceTicket: 'Unit Price (Ticket)',
      unitPricePiece: 'Unit Price (Piece)',
      tripPrice: 'Trip Price',
      kmPrice: 'Price Per KM',
      minKm: 'Minimum KM',
      vehicleType: 'Vehicle Type',
      vehicleCapacity: 'Vehicle Capacity (ton)',
      vehicleVolume: 'Vehicle Volume (m³)',
      weightStart: 'Start Weight',
      weightStartKg: 'Start Weight (KG)',
      weightEnd: 'End Weight',
      weightEndKg: 'End Weight (KG)',
      chargeName: 'Fee Name',
      surchargeBillingMode: 'Billing Mode',
      measure: 'Unit',
      unitRate: 'Unit Rate',
      fixedAmount: 'Fixed Amount',
      amount: 'Amount',
      baseCost: 'Base Cost',
      onePrice: 'One-price',
      totalPrice: 'Total Price',
      onePriceAmount: 'One-price Total',
      onePriceCurrency: 'One-price Currency',
      onePriceIncludedItems: 'Included Items',
      onePriceRemarks: 'One-price Remarks',
      prepaidCollect: 'Prepaid/Collect',
      prepaid: 'Prepaid',
      collect: 'Collect',
      isCountTotal: 'Included in Total',
      isTotalIncluded: 'Already Included',
      totalAmount: 'Total Amount',
      totalAmountByCurrency: 'Total by Currency',
      currentVersion: 'Current Version',
      changeContent: 'Change Content',
      consultationRemarks: 'Consultation Remarks'
    },
    actions: {
      addPlan: 'Add Plan',
      deletePlan: 'Delete Plan',
      addRow: 'Add Row',
      deleteRow: 'Delete',
      addSurcharge: 'Add Surcharge',
      saveDraft: 'Save Draft',
      submit: 'Submit Quote',
      cancel: 'Cancel',
      consultationComplete: 'Consultation Complete'
    },
    placeholders: {
      input: 'Please enter',
      select: 'Please select',
      optional: 'Optional',
      unlimited: 'Leave blank for no upper limit',
      onePriceIncludedItems: 'Required. Describe the fee items included in the one-price quote, such as base freight, port fees, and surcharges',
      onePriceRemarks: 'Describe the included fee scope, conditions, or other notes for the one-price quote...'
    },
    enums: {
      status: {
        draft: 'Draft',
        submitted: 'Submitted',
        imported: 'Imported'
      },
      surchargeBillingMode: {
        FIRST_ADDITIONAL: 'First + Additional',
        UNIT_PRICE: 'Unit Price',
        FIXED: 'Fixed Fee',
        PERCENTAGE: 'Percentage Fee'
      },
      boolean: {
        yes: 'Yes',
        no: 'No'
      },
      consultationStatus: {
        notConsulted: 'Not Consulted',
        inProgress: 'Consulting',
        completed: 'Completed'
      },
      palletNature: {
        inquiry: 'Inquiry',
        actual: 'Actual Shipment'
      },
      cargoReadyTimeRange: {
        1: 'Within 1 week',
        2: 'Within 2 weeks',
        3: 'Within 1 month',
        4: 'Over 1 month',
        5: 'Unknown'
      },
      directTransit: {
        direct: 'Direct',
        transit: 'Transit',
        unspecified: 'Unspecified'
      }
    },
    consultationRecords: {
      expectedPrice: 'Expected Price',
      note: 'Negotiation Note',
      status: 'Status',
      changeContent: 'Quotation Changes',
      consulting: 'In Negotiation',
      replied: 'Replied',
      currentRound: 'Current Round',
      changeAdded: 'Added {project}: {amount}',
      changeRemoved: 'Removed {project}, previous price {amount}',
      changeAdjusted: '{project} adjusted from {oldAmount} to {newAmount}',
      changeReplaced: '{oldProject} {oldAmount} changed to {newProject} {newAmount}',
      projects: {
        price: 'Price',
        onePrice: 'One Price',
        firstWeight: 'First Weight Price ({weight} KG)',
        additionalWeight: 'Additional Weight Price ({weight} KG)',
        minCharge: 'Minimum Charge',
        unitPrice: 'Unit Price',
        tripPrice: 'Trip Price',
        kmPrice: 'Price per Kilometer',
        weightTier: 'Weight Tier {start}-{end} KG {metric}',
        surcharge: 'Surcharge "{name}" {metric}',
        firstWeightPrice: 'First Weight Price',
        additionalWeightPrice: 'Additional Weight Price'
      }
    },
    calculationWarnings: {
      CONTEXT_REQUIRED: 'Calculation context is missing, so the total cannot be calculated yet',
      WEIGHT_REQUIRED: 'A valid billing weight is missing, so the total cannot be calculated yet',
      SIZE_REQUIRED: 'Complete cargo dimensions are required to calculate volumetric weight',
      PIECES_REQUIRED: 'A valid piece count is required to calculate volumetric weight',
      VOLUME_REQUIRED: 'A valid volume is missing, so the total cannot be calculated yet',
      PRICE_DETAIL_REQUIRED: 'Pricing details are incomplete, so the total cannot be calculated yet',
      WEIGHT_TIER_NOT_MATCHED: 'The billing weight does not match any weight tier',
      SURCHARGE_MEASURE_REQUIRED: 'The surcharge billing unit could not be resolved, so the total cannot be calculated yet',
      SURCHARGE_PERCENTAGE_INVALID: 'The fuel surcharge percentage must be between 0 and 100',
      SURCHARGE_PERCENTAGE_NOT_ALLOWED: 'Non-fuel surcharges cannot use percentage billing'
    },
    messages: {
      missingId: 'Missing quotation ID',
      tokenInvalid: 'The quotation link is invalid or expired',
      quotationExpired: 'The quotation deadline has passed. This quotation is now read-only.',
      loadFailed: 'Failed to load express quotation',
      saveSuccess: 'Saved successfully',
      saveFailed: 'Save failed',
      submitSuccess: 'Submitted successfully',
      submitFailed: 'Submit failed',
      planCreated: 'Plan created',
      planCreateFailed: 'Failed to create plan',
      deletePlanTitle: 'Delete Plan',
      deletePlanContent: 'Delete the current quotation plan? This action cannot be undone.',
      planDeleteSuccess: 'Plan deleted',
      planDeleteFailed: 'Failed to delete plan',
      noChange: 'No changes',
      noConsultationRecords: 'No consultation records',
      requiredField: 'Please enter/select {field}',
      validPeriodInvalid: 'The valid period end time cannot be earlier than the start time',
      weightTierMissing: 'Please enter at least one weight tier',
      weightTierRequired: 'Complete weight tier row {index}; price values must be valid non-negative numbers',
      weightTierPriceModeInvalid: 'In weight tier row {index}, enter either unit price (optional additional weight price) or minimum charge (total price), and leave unused price fields blank',
      weightTierRangeInvalid: 'End weight must be greater than start weight in weight tier row {index}',
      weightTierOpenEndedLast: 'An open-ended weight tier must be the last row',
      surchargeRequired: 'Please complete fee name, billing mode, unit, currency, and payment term for surcharge row {index}',
      surchargeFirstAdditionalRequired: 'Please complete first/additional weight fields for surcharge row {index}',
      surchargeAmountRequired: 'Please enter unit rate for surcharge row {index}',
      surchargePercentageRange: 'The percentage in surcharge row {index} must be between 0 and 100',
      surchargeAtLeastOne: 'At least one surcharge row is required',
      onePriceAmountRequired: 'Please enter the one-price total amount',
      onePriceCurrencyRequired: 'Please select the one-price currency',
      onePriceIncludedItemsRequired: 'Please enter the included items for the one-price quotation',
      planHasRequiredField: 'Plan {index} has required fields not filled'
    }
  },

  supplierFclQuotation: {
    title: 'Sea Quotation Detail',
    inquiryTitle: 'Sea Inquiry',
    planCount: '{count} plan(s)',
    planTitle: 'Plan {index}',
    emptyPlans: 'No quotation plans',
    emptyFees: 'No fees',
    quotationNotExist: 'Quotation plan does not exist',
    sections: {
      quotationDetail: 'Quotation Detail',
      consultationHistory: 'Consultation History',
      basic: 'Basic Information',
      cargo: 'Cargo Information',
      plans: 'Quotation Plans',
      prePort: 'Pre-Port',
      sea: 'Sea',
      lastMile: 'Last Mile',
      other: 'Other',
      baseFee: 'Base Fee',
      baseOceanFee: 'Base Ocean Freight',
      surcharge: 'Surcharge',
      oceanSurcharge: 'Ocean Surcharge',
      originPortFee: 'Origin Port Fee',
      destinationPortFee: 'Destination Port Fee',
      potentialFee: 'Potential Fee',
      files: 'Attachments',
      remarks: 'Remarks'
    },
    fields: {
      inquiryNo: 'Inquiry No.',
      quotationNo: 'Quotation No.',
      carrier: 'Carrier',
      loadingCountry: 'Loading Country',
      loadingCity: 'Loading City',
      loadingPort: 'Loading Port',
      destinationCountry: 'Destination Country',
      destinationCity: 'Destination City',
      destinationPort: 'Destination Port',
      directTransit: 'Direct/Transit',
      direct: 'Direct',
      transit: 'Transit',
      cargoReadyTime: 'Cargo Ready Time',
      cargoType: 'Cargo Type',
      unNo: 'UN No.',
      hazardClass: 'Class',
      cargoName: 'Cargo Name',
      hsCode: 'HS Code',
      cargoValue: 'Cargo Value (Currency)',
      onePrice: 'One Price',
      quotationDeadline: 'Quotation Deadline',
      specialRequirements: 'Special Requirements',
      serviceType: 'Service Type',
      containerType: 'Container Type',
      containerNum: 'Quantity',
      quantityPerContainer: 'Qty/Container',
      weightPerContainer: 'Gross Weight/Container',
      lengthPerContainer: 'Length/Container',
      widthPerContainer: 'Width/Container',
      heightPerContainer: 'Height/Container',
      totalQuantity: 'Total Qty',
      totalWeight: 'Total Gross Weight',
      totalVolume: 'Total Volume',
      summaryQuantity: 'Total Quantity',
      summaryWeight: 'Total Gross Weight',
      summaryVolume: 'Total Volume',
      temperatureRange: 'Temperature Range',
      ventilationDoor: 'Ventilation Door',
      ventilationQuantity: 'Ventilation',
      humidity: 'Humidity',
      needPrecooling: 'Pre-cooling',
      remarks: 'Remarks',
      packageType: 'Package Type',
      quantity: 'Quantity',
      weight: 'Gross Weight (KGS)',
      length: 'Length (CM)',
      width: 'Width (CM)',
      height: 'Height (CM)',
      lengthM: 'Length (M)',
      widthM: 'Width (M)',
      heightM: 'Height (M)',
      // RORO fields
      transportCategory: 'Transport Category',
      vehicleType: 'Vehicle Type',
      vehicleBrand: 'Brand',
      vehicleModel: 'Model',
      equipmentName: 'Equipment Name',
      isCrawler: 'Crawler',
      isSelfPropelled: 'Self-Propelled',
      isOversized: 'Oversized',
      canDeckLoad: 'Deck Loading',
      specialFixingRequirement: 'Special Fixing Requirement',
      outerLength: 'Outer Length (CM)',
      outerWidth: 'Outer Width (CM)',
      outerHeight: 'Outer Height (CM)',
      grossWeight: 'Gross Weight (KGS)',
      // BULK fields
      bulkCargoName: 'Cargo Name',
      stowageFactor: 'Stowage Factor',
      liftingRequirement: 'Lifting Requirement',
      unitWeight: 'Unit Gross Weight (KGS)',
      unitLength: 'Unit Length (CM)',
      unitWidth: 'Unit Width (CM)',
      unitHeight: 'Unit Height (CM)',
      isOnePrice: 'One Price',
      validPeriod: 'Price Valid Period',
      pPickupPort: 'Pickup Port',
      pCarrier: 'Carrier',
      pVessel: 'Barge Vessel',
      pVoyage: 'Barge Voyage',
      pBargeEtd: 'Barge ETD',
      pBargeEta: 'Barge ETA',
      pTransportationDays: 'Barge Transit Days',
      pPickupRailwayStation: 'Pickup Station',
      pRailCompany: 'Railway Company',
      pRailLineType: 'Line Type',
      pRailTrainNo: 'Train No.',
      pRailDepartureTime: 'Departure Time',
      pLoadingPort: 'Loading Port',
      pStuffingTerminal: 'Loading Terminal',
      pLoadingRailwayStation: 'Loading Station',
      pLoadingAirport: 'Loading Airport',
      pLoadingAirportTerminal: 'Airport Terminal',
      dischargePort: 'Destination Port',
      transferPort: 'Transfer Port',
      vessel: 'Vessel',
      voyage: 'Voyage',
      etd: 'ETD',
      eta: 'ETA',
      transportationDays: 'Transit Days',
      weekdays: 'Sailing Days',
      demurrage: 'Demurrage',
      detention: 'Detention',
      overweight: 'Weight Limit',
      lDischargingPort: 'Discharging Port',
      lDeliveryTerminal: 'Discharging Terminal',
      lDischargingStation: 'Discharging Station',
      lDischargingAirport: 'Discharging Airport',
      lAirportCargoTerminal: 'Airport Cargo Terminal',
      lDestinationPort: 'Destination',
      lVessel: 'Barge Vessel',
      lVoyage: 'Barge Voyage',
      lBargeEtd: 'Barge ETD',
      lBargeEta: 'Barge ETA',
      lTransportationDays: 'Barge Transit Days',
      lDestinationStation: 'Destination Station',
      lRailCompany: 'Railway Company',
      lRailLineType: 'Line Type',
      lRailTrainNo: 'Train No.',
      lRailDepartureTime: 'Departure Time',
      feeName: 'Fee Name',
      feeType: 'Fee Type',
      measure: 'Unit',
      containerTypeAndNum: 'Container Type & Qty',
      unitRate: 'Unit Rate',
      currency: 'Currency',
      paymentTerm: 'Payment Term',
      files: 'Attachments',
      totalAmountByCurrency: 'Total by Currency',
      currentVersion: 'Current Version',
      contactPhone: 'Phone',
      contactEmail: 'Email'
    },
    actions: {
      addPlan: 'Add Plan',
      deletePlan: 'Delete Plan',
      addSurcharge: 'Add Surcharge',
      addPotentialFee: 'Add Potential Fee',
      addOriginPortFee: 'Add Origin Port Fee',
      addDestinationPortFee: 'Add Destination Port Fee',
      addOceanSurcharge: 'Add Ocean Surcharge',
      addBaseFee: 'Add Base Fee',
      addOceanFreight: 'Add Ocean Freight',
      save: 'Save',
      submit: 'Submit',
      initiateConsultation: 'Initiate Consultation',
      consultationContent: 'Consultation Content',
      consultationContentPlaceholder: 'Enter consultation content',
      cancel: 'Cancel',
      consultationComplete: 'Consultation Complete',
      confirm: 'Confirm'
    },
    placeholders: {
      input: 'Please input',
      select: 'Please select',
      search: 'Search',
      selectDate: 'Select date'
    },
    messages: {
      loadFailed: 'Failed to load quotation data',
      saveSuccess: 'Saved successfully',
      saveFailed: 'Failed to save',
      submitSuccess: 'Submitted successfully',
      submitFailed: 'Failed to submit',
      planCreated: 'Plan created successfully',
      planCreateFailed: 'Failed to create plan',
      planDeleteSuccess: 'Plan deleted successfully',
      planDeleteFailed: 'Failed to delete plan',
      deletePlanTitle: 'Confirm Deletion',
      deletePlanContent: 'Are you sure to delete the current quotation plan?',
      tokenInvalid: 'Link invalid or expired',
      quotationExpired: 'Quotation has expired',
      missingId: 'Missing quotation plan ID',
      requiredField: 'Please fill in {field}',
      validPeriodRequired: 'Please fill in the price valid period',
      duplicateFeeName: 'Duplicate fee name is not allowed',
      planHasRequiredField: 'Plan {index} has required fields not filled',
      initiateConsultationSuccess: 'Consultation initiated successfully',
      initiateConsultationFailed: 'Failed to initiate consultation',
      consultationContentRequired: 'Please enter consultation content'
    },
    consultationRecords: {
      currentVersion: 'Current Version',
      expectedPrice: 'Expected Price',
      note: 'Note',
      status: 'Status',
      consulting: 'Consulting',
      replied: 'Replied',
      changeContent: 'Change Content',
      messages: {
        noChange: 'No changes in this round',
        noConsultationRecords: 'No consultation records'
      },
      feeCategories: {
        PRE_PORT_BASE: 'Pre-Port - Base Fee',
        PRE_PORT_SURCHARGE: 'Pre-Port - Surcharge',
        PRE_PORT_POTENTIAL: 'Pre-Port - Potential Fee',
        SEA_BASE: 'Sea - Base Ocean Freight',
        SEA_SURCHARGE: 'Sea - Surcharge',
        SEA_ORIGIN_PORT: 'Sea - Origin Port Fee',
        SEA_DEST_PORT: 'Sea - Destination Port Fee',
        SEA_POTENTIAL: 'Sea - Potential Fee',
        LAST_MILE_BASE: 'Last Mile - Base Fee',
        LAST_MILE_SURCHARGE: 'Last Mile - Surcharge',
        LAST_MILE_POTENTIAL: 'Last Mile - Potential Fee'
      },
      changeTypes: {
        added: 'Added',
        removed: 'Removed',
        adjusted: 'Adjusted'
      }
    },
    enums: {
      serviceType: {
        FCL: 'FCL',
        LCL: 'LCL',
        RORO: 'RORO',
        BULK: 'Bulk Cargo'
      },
      transportCategory: {
        1: 'Various Vehicles',
        2: 'Wheeled/Tracked Equipment',
        3: 'RoRo Pallet/Unit Cargo',
        4: 'Large Components w/ Running Wheels'
      },
      paymentTerm: {
        PREPAID: 'Prepaid',
        COLLECT: 'Collect'
      },
      potentialFeeType: {
        SEA_SURCHARGE: 'Sea Surcharge',
        ORIGIN_PORT: 'Origin Port Fee',
        DEST_PORT: 'Destination Port Fee'
      },
      consultationStatus: {
        1: 'Not Started',
        2: 'In Progress',
        3: 'Completed'
      }
    }
  },

  supplierAirQuotation: {
    title: 'Air Quotation Detail',
    inquiryTitle: 'Air Inquiry',
    planCount: '{count} plan(s)',
    planTitle: 'Plan {index}',
    emptyPlans: 'No quotation plans',
    emptyFees: 'No fees',
    quotationNotExist: 'Quotation plan does not exist',
    sections: {
      quotationDetail: 'Quotation Detail',
      consultationHistory: 'Consultation History',
      basic: 'Basic Information',
      cargo: 'Cargo Information',
      plans: 'Quotation Plans',
      prePort: 'Pre-Port',
      air: 'Air',
      lastMile: 'Last Mile',
      other: 'Other',
      baseFee: 'Base Fee',
      surcharge: 'Surcharge',
      originFee: 'Origin Fee',
      destFee: 'Destination Fee',
      potentialFee: 'Potential Fee',
      files: 'Attachments',
      remarks: 'Remarks'
    },
    fields: {
      quotationNo: 'Quotation No.',
      inquiryNature: 'Inquiry Nature',
      paymentMethod: 'Payment Method',
      transportClause: 'Transport Clause',
      serviceTerm: 'Service Term',
      carrier: 'Carrier',
      loadingCountry: 'Loading Country',
      loadingCity: 'Loading City',
      loadingAirport: 'Loading Airport',
      destinationCountry: 'Destination Country',
      destinationCity: 'Destination City',
      destinationAirport: 'Destination Airport',
      directTransit: 'Direct/Transit',
      cargoReadyTime: 'Cargo Ready Time',
      expectedSailingTime: 'Expected ETD',
      cargoType: 'Cargo Type',
      unNo: 'UN No.',
      hazardClass: 'Class',
      cargoName: 'Cargo Name',
      hsCode: 'HS Code',
      cargoValue: 'Cargo Value',
      onePrice: 'One Price',
      quotationDeadline: 'Quotation Deadline',
      specialRequirements: 'Special Requirements',
      serviceType: 'Service Type',
      airPalletType: 'Air Pallet Type',
      palletCount: 'Pallet Count',
      quantity: 'Quantity',
      weight: 'Gross Weight (KGS)',
      length: 'Length (CM)',
      width: 'Width (CM)',
      height: 'Height (CM)',
      lengthM: 'Length (M)',
      widthM: 'Width (M)',
      heightM: 'Height (M)',
      packageType: 'Package Type',
      temperatureRange: 'Temperature Range',
      ventilationDoor: 'Ventilation Door',
      ventilationQuantity: 'Ventilation',
      humidity: 'Humidity',
      needPrecooling: 'Pre-cooling',
      totalQuantity: 'Total Qty',
      totalWeight: 'Total Gross Weight',
      totalVolume: 'Total Volume',
      summaryQuantity: 'Total Quantity',
      summaryWeight: 'Total Gross Weight',
      summaryVolume: 'Total Volume',
      remarks: 'Remarks',
      containerEquipment: 'Container Equipment',
      exclusiveCargoHold: 'Exclusive Cargo Hold',
      handlingRequirement: 'Handling Requirement',
      preferredAircraftType: 'Preferred Aircraft Type',
      singleBoardQuantity: 'Qty/Pallet',
      singleBoardWeight: 'Gross Weight/Pallet',
      singleBoardLength: 'Length/Pallet',
      singleBoardWidth: 'Width/Pallet',
      singleBoardHeight: 'Height/Pallet',
      singlePieceQuantity: 'Single Qty',
      singlePieceWeight: 'Single Weight',
      singlePieceLength: 'Single Length',
      singlePieceWidth: 'Single Width',
      singlePieceHeight: 'Single Height',
      maxPieceLength: 'Max Length',
      maxPieceWidth: 'Max Width',
      maxPieceHeight: 'Max Height',
      flightNo: 'Flight No.',
      transitAirport: 'Transit Airport',
      flightDepartureTime: 'Departure Time',
      flightArrivalTime: 'Arrival Time',
      weekdays: 'Schedule',
      routeLevel: 'Route Level',
      pPickupPort: 'Pickup Port',
      pCarrier: 'Carrier',
      pVessel: 'Barge Vessel',
      pVoyage: 'Barge Voyage',
      pBargeEtd: 'Barge ETD',
      pBargeEta: 'Barge ETA',
      pTransportationDays: 'Barge Transit Days',
      pPickupRailwayStation: 'Pickup Station',
      pRailCompany: 'Railway Company',
      pRailLineType: 'Line Type',
      pRailTrainNo: 'Train No.',
      pRailDepartureTime: 'Departure Time',
      pLoadingPort: 'Loading Port',
      pStuffingTerminal: 'Loading Terminal',
      pLoadingRailwayStation: 'Loading Station',
      pLoadingAirport: 'Loading Airport',
      pAirportTerminal: 'Airport Terminal',
      lDischargingPort: 'Discharging Port',
      lDeliveryTerminal: 'Discharging Terminal',
      lDischargingStation: 'Discharging Station',
      lDischargingAirport: 'Discharging Airport',
      lAirportTerminal: 'Airport Terminal',
      lDestinationPort: 'Destination',
      lVessel: 'Barge Vessel',
      lVoyage: 'Barge Voyage',
      lBargeEtd: 'Barge ETD',
      lBargeEta: 'Barge ETA',
      lTransportationDays: 'Barge Transit Days',
      lDestinationStation: 'Destination Station',
      lRailCompany: 'Railway Company',
      lRailLineType: 'Line Type',
      lRailTrainNo: 'Train No.',
      lRailDepartureTime: 'Departure Time',
      feeName: 'Fee Name',
      feeType: 'Fee Type',
      measure: 'Unit',
      unitRate: 'Unit Rate',
      currency: 'Currency',
      paymentTerm: 'Payment Term',
      densityLevel: 'Density Level',
      hitDensityLevel: 'Hit Density Level',
      hitWeightSection: 'Hit Weight Section',
      tierM: 'M',
      tierN: 'N',
      tier45: '45+',
      tier100: '100+',
      tier300: '300+',
      tier500: '500+',
      tier700: '700+',
      tier1000: '1000+',
      tier2000: '2000+',
      files: 'Attachments',
      totalAmountByCurrency: 'Total by Currency',
      contactPhone: 'Phone',
      contactEmail: 'Email',
      validPeriod: 'Price Valid Period',
      supplierRemarks: 'Supplier Remarks'
    },
    actions: {
      addPlan: 'Add Plan',
      deletePlan: 'Delete Plan',
      addBaseFee: 'Add Base Fee',
      addSurcharge: 'Add Surcharge',
      addOriginFee: 'Add Origin Fee',
      addDestFee: 'Add Destination Fee',
      addPotentialFee: 'Add Potential Fee',
      save: 'Save',
      submit: 'Submit',
      initiateConsultation: 'Initiate Consultation',
      consultationContent: 'Consultation Content',
      consultationContentPlaceholder: 'Enter consultation content',
      cancel: 'Cancel',
      consultationComplete: 'Consultation Complete',
      confirm: 'Confirm'
    },
    placeholders: {
      input: 'Please input',
      select: 'Please select',
      search: 'Search',
      selectDate: 'Select date'
    },
    messages: {
      loadFailed: 'Failed to load quotation data',
      saveSuccess: 'Saved successfully',
      saveFailed: 'Failed to save',
      submitSuccess: 'Submitted successfully',
      submitFailed: 'Failed to submit',
      planCreated: 'Plan created successfully',
      planCreateFailed: 'Failed to create plan',
      planDeleteSuccess: 'Plan deleted successfully',
      planDeleteFailed: 'Failed to delete plan',
      deletePlanTitle: 'Confirm Deletion',
      deletePlanContent: 'Are you sure to delete the current quotation plan?',
      tokenInvalid: 'Link invalid or expired',
      quotationExpired: 'Quotation has expired',
      missingId: 'Missing quotation plan ID',
      requiredField: 'Please fill in {field}',
      validPeriodRequired: 'Please fill in the price valid period',
      duplicateFeeName: 'Duplicate fee name is not allowed',
      planHasRequiredField: 'Plan {index} has required fields not filled',
      initiateConsultationSuccess: 'Consultation initiated successfully',
      initiateConsultationFailed: 'Failed to initiate consultation',
      consultationContentRequired: 'Please enter consultation content'
    },
    consultationRecords: {
      currentVersion: 'Current Version',
      expectedPrice: 'Expected Price',
      note: 'Note',
      status: 'Status',
      consulting: 'Consulting',
      replied: 'Replied',
      changeContent: 'Changes',
      noChange: 'No changes',
      messages: {
        noChange: 'No changes in this round',
        noConsultationRecords: 'No consultation records'
      },
      feeCategories: {
        PRE_PORT_BASE: 'Pre-Port Base',
        PRE_PORT_SURCHARGE: 'Pre-Port Surcharge',
        PRE_PORT_POTENTIAL: 'Pre-Port Potential',
        AIR_BASE: 'Air Base Fee',
        AIR_SURCHARGE: 'Air Surcharge',
        AIR_ORIGIN: 'Air Origin Fee',
        AIR_DEST: 'Air Destination Fee',
        AIR_POTENTIAL: 'Air Potential Fee',
        LAST_MILE_BASE: 'Last-Mile Base',
        LAST_MILE_SURCHARGE: 'Last-Mile Surcharge',
        LAST_MILE_POTENTIAL: 'Last-Mile Potential'
      },
      changeTypes: {
        added: 'Added',
        removed: 'Removed',
        adjusted: 'Adjusted'
      }
    },
    enums: {
      airServiceType: {
        CONSOL: 'CONSOL',
        FULL_PALLET: 'Full Pallet',
        BLOCK_SPACE: 'Block Space',
        FULL_CHARTER: 'Full Charter'
      },
      routeLevel: {
        EXPRESS: 'Express',
        STANDARD: 'Standard',
        ECONOMY: 'Economy'
      },
      airPotentialFeeType: {
        ORIGIN: 'Origin Fee',
        DEST: 'Destination Fee',
        SURCHARGE: 'Air Surcharge'
      },
      paymentTerm: {
        PREPAID: 'Prepaid',
        COLLECT: 'Collect'
      },
      consultationStatus: {
        1: 'Not Started',
        2: 'In Progress',
        3: 'Completed'
      }
    }
  },

  supplierRailQuotation: {
    title: 'Rail Quotation Detail',
    inquiryTitle: 'Rail Inquiry',
    planCount: '{count} plan(s)',
    planTitle: 'Plan {index}',
    emptyPlans: 'No quotation plans',
    emptyFees: 'No fees',
    quotationNotExist: 'Quotation plan does not exist',
    sections: {
      quotationDetail: 'Quotation Detail',
      consultationHistory: 'Consultation History',
      basic: 'Basic Information',
      cargo: 'Cargo Information',
      plans: 'Quotation Plans',
      prePort: 'Pre-Port',
      rail: 'Rail',
      lastMile: 'Last Mile',
      baseFee: 'Base Fee',
      surcharge: 'Surcharge',
      potentialFee: 'Potential Fee',
      files: 'Attachments',
      remarks: 'Remarks',
      containerBasicFee: 'Container Basic Fee',
      truckBasicFee: 'Truck Basic Fee',
      bulkBasicFee: 'Bulk Basic Fee'
    },
    fields: {
      quotationNo: 'Quotation No.',
      carrier: 'Railway Company',
      loadingCountry: 'Loading Country',
      loadingCity: 'Loading City',
      loadingStation: 'Loading Station',
      destinationCountry: 'Destination Country',
      destinationCity: 'Destination City',
      destinationStation: 'Destination Station',
      routeType: 'Route Type',
      directTransit: 'Direct/Transit',
      direct: 'Direct',
      transit: 'Transit',
      transferStation: 'Transfer Station',
      cargoReadyTime: 'Cargo Ready Time',
      serviceType: 'Service Type',
      cargoType: 'Cargo Type',
      unNo: 'UN No.',
      hazardClass: 'Class',
      cargoName: 'Cargo Name',
      hsCode: 'HS Code',
      cargoValue: 'Cargo Value',
      onePrice: 'One Price',
      isOnePrice: 'One Price',
      quotationDeadline: 'Quotation Deadline',
      specialRequirements: 'Special Requirements',
      containerType: 'Container Type',
      containerNum: 'Container Qty',
      quantityPerContainer: 'Qty/Container',
      weightPerContainer: 'Gross Weight/Container',
      lengthPerContainer: 'Length/Container',
      widthPerContainer: 'Width/Container',
      heightPerContainer: 'Height/Container',
      totalQuantity: 'Total Qty',
      totalWeight: 'Total Gross Weight',
      totalVolume: 'Total Volume',
      summaryQuantity: 'Total Quantity',
      summaryWeight: 'Total Gross Weight',
      summaryVolume: 'Total Volume',
      temperatureRange: 'Temperature Range',
      ventilationDoor: 'Ventilation Door',
      ventilationQuantity: 'Ventilation',
      humidity: 'Humidity',
      needPrecooling: 'Pre-cooling',
      vehicleType: 'Vehicle Type',
      quantity: 'Quantity',
      weight: 'Gross Weight (KGS)',
      length: 'Length (CM)',
      width: 'Width (CM)',
      height: 'Height (CM)',
      lengthM: 'Length (M)',
      widthM: 'Width (M)',
      heightM: 'Height (M)',
      packageType: 'Package Type',
      remarks: 'Remarks',
      weekdays: 'Schedule',
      trainDepartureTime: 'Departure Time',
      borderCrossTime: 'Border Cross Time',
      trainArrivalTime: 'Arrival Time',
      overweightRemarks: 'Weight Limit',
      demurrageFreeDays: 'Free Storage (Days)',
      truckType: 'Truck Type',
      stdWeight: 'Std. Weight',
      basePrice1: 'Base Price 1',
      basePrice2: 'Base Price 2',
      minCharge: 'Min Charge',
      maxCharge: 'Max Charge',
      feeName: 'Fee Name',
      feeType: 'Fee Type',
      measure: 'Unit',
      containerTypeAndNum: 'Container Type & Qty',
      unitRate: 'Unit Rate',
      currency: 'Currency',
      paymentTerm: 'Payment Term',
      validPeriod: 'Price Valid Period',
      files: 'Attachments',
      totalAmountByCurrency: 'Total by Currency',
      contactPhone: 'Phone',
      contactEmail: 'Email',
      pPickupPort: 'Pickup Port',
      pCarrier: 'Carrier',
      pVessel: 'Barge Vessel',
      pVoyage: 'Barge Voyage',
      pBargeEtd: 'Barge ETD',
      pBargeEta: 'Barge ETA',
      pTransportationDays: 'Barge Transit Days',
      pPickupRailwayStation: 'Pickup Station',
      pRailCompany: 'Railway Company',
      pRailLineType: 'Line Type',
      pRailTrainNo: 'Train No.',
      pRailDepartureTime: 'Departure Time',
      pLoadingPort: 'Loading Port',
      pStuffingTerminal: 'Loading Terminal',
      pLoadingRailwayStation: 'Loading Station',
      pLoadingAirport: 'Loading Airport',
      pAirportTerminal: 'Airport Terminal',
      lDischargingPort: 'Discharging Port',
      lDeliveryTerminal: 'Discharging Terminal',
      lDischargingStation: 'Discharging Station',
      lDischargingAirport: 'Discharging Airport',
      lAirportTerminal: 'Airport Terminal',
      lDestinationPort: 'Destination',
      lVessel: 'Barge Vessel',
      lVoyage: 'Barge Voyage',
      lBargeEtd: 'Barge ETD',
      lBargeEta: 'Barge ETA',
      lTransportationDays: 'Barge Transit Days',
      lDestinationStation: 'Destination Station',
      lRailCompany: 'Railway Company',
      lRailLineType: 'Line Type',
      lRailTrainNo: 'Train No.',
      lRailDepartureTime: 'Departure Time'
    },
    actions: {
      addPlan: 'Add Plan',
      deletePlan: 'Delete Plan',
      addBaseFee: 'Add Base Fee',
      addSurcharge: 'Add Surcharge',
      addPotentialFee: 'Add Potential Fee',
      save: 'Save',
      submit: 'Submit',
      initiateConsultation: 'Initiate Consultation',
      consultationContent: 'Consultation Content',
      consultationContentPlaceholder: 'Enter consultation content',
      cancel: 'Cancel',
      consultationComplete: 'Consultation Complete',
      confirm: 'Confirm'
    },
    placeholders: {
      input: 'Please input',
      select: 'Please select',
      search: 'Search',
      selectDate: 'Select date'
    },
    messages: {
      loadFailed: 'Failed to load quotation data',
      saveSuccess: 'Saved successfully',
      saveFailed: 'Failed to save',
      submitSuccess: 'Submitted successfully',
      submitFailed: 'Failed to submit',
      planCreated: 'Plan created successfully',
      planCreateFailed: 'Failed to create plan',
      planDeleteSuccess: 'Plan deleted successfully',
      planDeleteFailed: 'Failed to delete plan',
      deletePlanTitle: 'Confirm Deletion',
      deletePlanContent: 'Are you sure to delete the current quotation plan?',
      tokenInvalid: 'Link invalid or expired',
      quotationExpired: 'Quotation has expired',
      requiredField: 'Please fill in {field}',
      validPeriodRequired: 'Please fill in the price valid period',
      planHasRequiredField: 'Plan {index} has required fields not filled',
      initiateConsultationSuccess: 'Consultation initiated successfully',
      initiateConsultationFailed: 'Failed to initiate consultation',
      consultationContentRequired: 'Please enter consultation content'
    },
    consultationRecords: {
      currentVersion: 'Current Version',
      expectedPrice: 'Expected Price',
      note: 'Note',
      status: 'Status',
      consulting: 'Consulting',
      replied: 'Replied',
      changeContent: 'Change Content',
      messages: {
        noChange: 'No changes in this round',
        noConsultationRecords: 'No consultation records'
      },
      feeCategories: {
        PRE_PORT_BASE: 'Pre-Port - Base Fee',
        PRE_PORT_SURCHARGE: 'Pre-Port - Surcharge',
        PRE_PORT_POTENTIAL: 'Pre-Port - Potential Fee',
        RAIL_BASE: 'Rail - Base Fee',
        RAIL_SURCHARGE: 'Rail - Surcharge',
        LAST_MILE_BASE: 'Last Mile - Base Fee',
        LAST_MILE_SURCHARGE: 'Last Mile - Surcharge',
        LAST_MILE_POTENTIAL: 'Last Mile - Potential Fee'
      },
      changeTypes: {
        added: 'Added',
        removed: 'Removed',
        adjusted: 'Adjusted'
      }
    },
    enums: {
      serviceType: {
        CONTAINER: 'Container',
        TRUCK: 'Truck',
        BULK: 'Bulk'
      },
      vehicleType: {
        1: 'Open Wagon',
        2: 'Covered Wagon',
        3: 'Flatcar',
        4: 'Refrigerated Car',
        5: 'Ore Car',
        6: 'Cement Car'
      },
      paymentTerm: {
        PREPAID: 'Prepaid',
        COLLECT: 'Collect'
      },
      consultationStatus: {
        1: 'Not Started',
        2: 'In Progress',
        3: 'Completed'
      }
    }
  },

  // Pre-port quotation detail page
  supplierPrePortQuotation: {
    title: 'Pre-Port Quotation Detail',
    inquiryTitle: 'Pre-Port Inquiry',
    planTitle: 'Plan {index}',
    emptyPlans: 'No quotation plans',
    emptyFees: 'No fees',

    fields: {
      quotationNo: 'Quotation No.',
      feeName: 'Fee Name',
      measure: 'Unit',
      containerTypeAndNum: 'Container Type & Qty',
      unitRate: 'Unit Rate',
      currency: 'Currency',
      paymentTerm: 'Payment Term',
      remarks: 'Remarks',
      files: 'Attachments',
      transportMode: 'Transport Mode',
      arrivalNodeType: 'Arrival Node',
      totalAmountByCurrency: 'Total by Currency',
      isOnePrice: 'All-In Rate',
      validPeriod: 'Valid Period',
      serviceType: 'Service Type',
      stuffingCity: 'Stuffing City',
      pickupPort: 'Pickup Port',
      pickupRailwayStation: 'Pickup Station',
      loadingPort: 'Loading Port',
      stuffingTerminal: 'Stuffing Terminal',
      loadingRailwayStation: 'Loading Station',
      loadingAirport: 'Loading Airport',
      airportTerminal: 'Airport Terminal',
      cargoReadyTime: 'Cargo Ready Time',
      cargoType: 'Cargo Type',
      unNo: 'UN No.',
      hazardClass: 'Hazard Class',
      cargoName: 'Cargo Name',
      hsCode: 'HS Code',
      cargoValue: 'Cargo Value',
      onePrice: 'All-In Rate',
      quotationDeadline: 'Quotation Deadline',
      specialRequirements: 'Special Requirements',
      containerType: 'Container Type',
      containerNum: 'Container Qty',
      quantityPerContainer: 'Qty/Container',
      weightPerContainer: 'Weight/Container (KG)',
      totalQuantity: 'Total Qty',
      totalWeight: 'Total Weight (KG)',
      totalVolume: 'Total Volume (CBM)',
      summaryQuantity: 'Total Quantity',
      summaryWeight: 'Total Gross Weight',
      summaryVolume: 'Total Volume',
      temperatureRange: 'Temperature (℃)',
      ventilationDoor: 'Ventilation Door',
      ventilationQuantity: 'Ventilation Qty',
      humidity: 'Humidity',
      needPrecooling: 'Pre-cooling',
      quantity: 'Qty',
      weight: 'Weight (KG)',
      length: 'Length (CM)',
      width: 'Width (CM)',
      height: 'Height (CM)',
      lengthM: 'Length (M)',
      widthM: 'Width (M)',
      heightM: 'Height (M)',
      packageType: 'Package Type',
      truckType: 'Vehicle Type'
    },

    enums: {
      paymentTerm: {
        PREPAID: 'Prepaid',
        COLLECT: 'Collect'
      },
      arrivalNodeType: {
        1: 'Sea Port',
        2: 'Railway Station',
        3: 'Airport'
      },
      transportMode: {
        1: 'Truck',
        2: 'Barge',
        3: 'Rail'
      },
      serviceType: {
        FCL: 'FCL',
        LCL: 'LCL',
        TRUCK: 'Truck'
      },
      truckType: {
        1: 'Open Car',
        2: 'Covered Car',
        3: 'Flatcar',
        4: 'Refrigerated Car',
        5: 'Ore Car',
        6: 'Cement Car'
      },
      consultationStatus: {
        1: 'Not Started',
        2: 'In Progress',
        3: 'Completed'
      }
    },

    sections: {
      basic: 'Basic Info',
      cargo: 'Cargo Info',
      plans: 'Quotation Plans',
      quotationDetail: 'Quotation Detail',
      consultationHistory: 'Consultation History',
      baseFee: 'Base Fee',
      surcharge: 'Surcharge',
      potentialFee: 'Potential Fee'
    },

    actions: {
      submit: 'Submit Quotation',
      addPlan: 'Add Plan',
      addBaseFee: 'Add Base Fee',
      addSurcharge: 'Add Surcharge',
      addPotentialFee: 'Add Potential Fee',
      save: 'Save',
      initiateConsultation: 'Initiate Consultation',
      consultationContent: 'Consultation Content',
      consultationContentPlaceholder: 'Enter consultation content',
      cancel: 'Cancel',
      consultationComplete: 'Consultation Complete'
    },

    messages: {
      tokenInvalid: 'Invalid access link',
      quotationExpired: 'Quotation has expired',
      loadFailed: 'Failed to load quotation info',
      saveSuccess: 'Saved successfully',
      saveFailed: 'Failed to save',
      quotationNotExist: 'Quotation plan not found',
      planCreated: 'Plan created successfully',
      planCreateFailed: 'Failed to create plan',
      deletePlanTitle: 'Delete Plan',
      deletePlanContent: 'Are you sure to delete the current quotation plan?',
      planDeleteSuccess: 'Plan deleted successfully',
      planDeleteFailed: 'Failed to delete plan',
      requiredField: '{field} is required',
      duplicateFeeName: 'Duplicate fee name, please select again',
      planHasRequiredField: 'Plan {index} has required fields not filled',
      submitSuccess: 'Quotation submitted successfully',
      submitFailed: 'Failed to submit quotation',
      validPeriodRequired: 'Please fill in the valid period',
      initiateConsultationSuccess: 'Consultation initiated successfully',
      initiateConsultationFailed: 'Failed to initiate consultation',
      consultationContentRequired: 'Please enter consultation content'
    },
    consultationRecords: {
      currentVersion: 'Current Version',
      expectedPrice: 'Expected Price',
      note: 'Note',
      status: 'Status',
      consulting: 'Consulting',
      replied: 'Replied',
      changeContent: 'Change Content',
      messages: {
        noChange: 'No changes in this round',
        noConsultationRecords: 'No consultation records'
      },
      feeCategories: {
        BASE: 'Base Fee',
        SURCHARGE: 'Surcharge',
        POTENTIAL: 'Potential Fee'
      },
      changeTypes: {
        added: 'Added',
        removed: 'Removed',
        adjusted: 'Adjusted'
      }
    },

    placeholders: {
      select: 'Please select',
      input: 'Please enter'
    }
  },

  // Last-mile quotation detail page
  supplierLastMileQuotation: {
    title: 'Last-Mile Quotation Detail',
    inquiryTitle: 'Last-Mile Inquiry',
    planTitle: 'Plan {index}',
    emptyPlans: 'No quotation plans',
    emptyFees: 'No fees',

    fields: {
      quotationNo: 'Quotation No.',
      feeName: 'Fee Name',
      measure: 'Unit',
      containerTypeAndNum: 'Container Type & Qty',
      unitRate: 'Unit Rate',
      currency: 'Currency',
      paymentTerm: 'Payment Term',
      remarks: 'Remarks',
      files: 'Attachments',
      lastMileTransportMode: 'Transport Mode',
      dischargingAddressType: 'Discharging Address Type',
      totalAmountByCurrency: 'Total by Currency',
      isOnePrice: 'All-In Rate',
      validPeriod: 'Valid Period',
      serviceType: 'Service Type',
      dischargingPort: 'Discharging Port',
      deliveryTerminal: 'Delivery Terminal',
      dischargingStation: 'Discharging Station',
      dischargingAirport: 'Discharging Airport',
      airportTerminal: 'Airport Terminal',
      destinationPort: 'Destination Port',
      destinationStation: 'Destination Station',
      dischargingCountry: 'Discharging Country',
      dischargingCity: 'Discharging City',
      destinationCountry: 'Destination Country',
      destinationCity: 'Destination City',
      deliveryAddressType: 'Delivery Address Type',
      deliveryCountry: 'Delivery Country',
      deliveryCity: 'Delivery City',
      deliveryAddress: 'Delivery Address',
      postalCode: 'Postal Code',
      cargoReadyTime: 'Cargo Ready Time',
      etd: 'Expected ETD',
      cargoType: 'Cargo Type',
      unNo: 'UN No.',
      hazardClass: 'Hazard Class',
      cargoName: 'Cargo Name',
      hsCode: 'HS Code',
      cargoValue: 'Cargo Value',
      onePrice: 'All-In Rate',
      quotationDeadline: 'Quotation Deadline',
      specialRequirements: 'Special Requirements',
      containerType: 'Container Type',
      containerNum: 'Container Qty',
      quantityPerContainer: 'Qty/Container',
      weightPerContainer: 'Weight/Container (KG)',
      totalQuantity: 'Total Qty',
      totalWeight: 'Total Weight (KG)',
      totalVolume: 'Total Volume (CBM)',
      summaryQuantity: 'Total Quantity',
      summaryWeight: 'Total Gross Weight',
      summaryVolume: 'Total Volume',
      temperatureRange: 'Temperature (℃)',
      ventilationDoor: 'Ventilation Door',
      ventilationQuantity: 'Ventilation Qty',
      humidity: 'Humidity',
      needPrecooling: 'Pre-cooling',
      quantity: 'Qty',
      weight: 'Weight (KG)',
      length: 'Length (CM)',
      width: 'Width (CM)',
      height: 'Height (CM)',
      lengthM: 'Length (M)',
      widthM: 'Width (M)',
      heightM: 'Height (M)',
      packageType: 'Package Type',
      truckType: 'Vehicle Type'
    },

    enums: {
      paymentTerm: {
        PREPAID: 'Prepaid',
        COLLECT: 'Collect'
      },
      transportMode: {
        1: 'Truck',
        2: 'Barge',
        3: 'Rail'
      },
      dischargingAddressType: {
        1: 'Sea Port',
        2: 'Railway Station',
        3: 'Airport'
      },
      serviceType: {
        FCL: 'FCL',
        LCL: 'LCL',
        TRUCK: 'Truck'
      },
      deliveryAddressType: {
        1: 'Third Party',
        2: 'Amazon',
        3: 'eCang'
      },
      truckType: {
        1: 'Open Car',
        2: 'Covered Car',
        3: 'Flatcar',
        4: 'Refrigerated Car',
        5: 'Ore Car',
        6: 'Cement Car'
      },
      consultationStatus: {
        1: 'Not Started',
        2: 'In Progress',
        3: 'Completed'
      }
    },

    sections: {
      basic: 'Basic Info',
      cargo: 'Cargo Info',
      plans: 'Quotation Plans',
      quotationDetail: 'Quotation Detail',
      consultationHistory: 'Consultation History',
      baseFee: 'Base Fee',
      surcharge: 'Surcharge',
      potentialFee: 'Potential Fee'
    },

    actions: {
      submit: 'Submit Quotation',
      addPlan: 'Add Plan',
      addBaseFee: 'Add Base Fee',
      addSurcharge: 'Add Surcharge',
      addPotentialFee: 'Add Potential Fee',
      save: 'Save',
      initiateConsultation: 'Initiate Consultation',
      consultationContent: 'Consultation Content',
      consultationContentPlaceholder: 'Enter consultation content',
      cancel: 'Cancel',
      consultationComplete: 'Consultation Complete'
    },

    messages: {
      tokenInvalid: 'Invalid access link',
      quotationExpired: 'Quotation has expired',
      loadFailed: 'Failed to load quotation info',
      saveSuccess: 'Saved successfully',
      saveFailed: 'Failed to save',
      quotationNotExist: 'Quotation plan not found',
      planCreated: 'Plan created successfully',
      planCreateFailed: 'Failed to create plan',
      deletePlanTitle: 'Delete Plan',
      deletePlanContent: 'Are you sure to delete the current quotation plan?',
      planDeleteSuccess: 'Plan deleted successfully',
      planDeleteFailed: 'Failed to delete plan',
      requiredField: '{field} is required',
      duplicateFeeName: 'Duplicate fee name, please select again',
      planHasRequiredField: 'Plan {index} has required fields not filled',
      submitSuccess: 'Quotation submitted successfully',
      submitFailed: 'Failed to submit quotation',
      validPeriodRequired: 'Please fill in the valid period',
      initiateConsultationSuccess: 'Consultation initiated successfully',
      initiateConsultationFailed: 'Failed to initiate consultation',
      consultationContentRequired: 'Please enter consultation content'
    },
    consultationRecords: {
      currentVersion: 'Current Version',
      expectedPrice: 'Expected Price',
      note: 'Note',
      status: 'Status',
      consulting: 'Consulting',
      replied: 'Replied',
      changeContent: 'Change Content',
      messages: {
        noChange: 'No changes in this round',
        noConsultationRecords: 'No consultation records'
      },
      feeCategories: {
        BASE: 'Base Fee',
        SURCHARGE: 'Surcharge',
        POTENTIAL: 'Potential Fee'
      },
      changeTypes: {
        added: 'Added',
        removed: 'Removed',
        adjusted: 'Adjusted'
      }
    },

    placeholders: {
      select: 'Please select',
      input: 'Please enter'
    }
  }
}
